import Overlay from '@components/overlays'

export default class Menu extends Overlay {
    constructor(menu, button) {
        super(menu, {
            stackable: true
        })

        this.button = button

        this.button.addEventListener('click', this.toggle)
    }

    open() {
        super.open()

		document.body.classList.add('has-menu')
        this.button.setAttribute('aria-expanded', true)
    }

    close() {
        super.close()

		document.body.classList.remove('has-menu')
		dispatchEvent(new CustomEvent('closesubmenus'))
        this.button.setAttribute('aria-expanded', false)
    }
}